<template>
    <div class="element-row">

        <label class="element-row_label">
            <span class="element-row_title">Кадастровый номер типового (эталонного) объекта недвижимости</span>
            <span class="element-row_info" title="Обязательное значение" v-b-tooltip:fullscreen.hover.bottomright><div><base-icon name="info" /></div></span>
            <span class="element-row_must">*</span>
        </label>

        <div class="element-row_fields">

            <div class="element-row_field">
                <b-form-input
                    ref="value_input" placeholder="Введите значение" size="sm"
                    v-model="value" @change="(value) => set_value('value', value)"
                    :readonly="readonly"
                    :state="state" aria-describedby="value"
                    @input="validate" :formatter="formatter"
                />
                <b-form-invalid-feedback id="value" tooltip>
                    Обязательное значение
                </b-form-invalid-feedback>
            </div>

            <element_with_source :data="data" class="element-row_field" :disabled="readonly"
                v-on:set_source="value => set_value('source', value)"
                v-on:set_file="value => set_value('file', value)"
            />

        </div>

    </div>
</template>

<script>
import api from "../../../../../../api";
import element_with_source from "../../../../../widgets/element"
import Reference_controller from "../controller";

export default {
    props :
    {
        controller : Reference_controller,
    },

    components :
    {
        element_with_source
    },

    data()
    {
        return {
            state: null,
            value: null,
            pattern: /[\d]{2}:[\d]{2}:[\d]{6,7}:[\d]+/
        }
    },

    computed :
    {
        data()
        {
            return this.controller.data.cad_num
        },

        readonly()
        {
            return !this.controller.check_roles([ 'model' ]) || this.controller.not_editable
        }
    },

    watch :
    {
        data :
        {
            handler()
            {
                this.value = this.data.value
                
                this.validate(this.value)
            },
            immediate: true
        }
    },

    methods :
    {
        formatter(value)
        {
            const splited_cad_num = value.split(":")

            const is_cad_num = [
                !splited_cad_num[0] || /^[\d]{0,2}$/.test(splited_cad_num[0]),
                !splited_cad_num[1] || /^[\d]{0,2}$/.test(splited_cad_num[1]),
                !splited_cad_num[2] || /^[\d]{0,7}$/.test(splited_cad_num[2]),
                !splited_cad_num[3] || /^[\d]*$/.test(splited_cad_num[3])
            ]

            if (value === "" || !is_cad_num.includes(false))
            {
                return value
            }
            else
            {
                return this.value
            }
        },

        validate(value)
        {
            this.pattern.test(value) || this.readonly ? this.state = null : this.state = false
        },
        
        set_value(key, value)
        {
            if (!this.readonly)
            {
                if (key === "value")
                {
                    if (this.pattern.test(value))
                    {
                        this.controller.object_by_cad_num(value)
                            .then((res) => {
                                if (res.length == 0)
                                {
                                    this.$bvModal.msgBoxOk("Объект оценки с таким Кадастровым номером отсутствует в данной группе", { okVariant: 'danger' })
        
                                    this.value = this.data.value
                                    this.validate(this.value)
                                }
                                else if (!api.get_attr_value(this.controller.attrs, res[0], "current_version.attrs.Area"))
                                {
                                    this.$bvModal.msgBoxOk("Отсутствует площадь", { okVariant: 'danger' })
        
                                    this.value = this.data.value
                                    this.validate(this.value)
                                }
                                else
                                {
                                    this.controller.set_field("cad_num." + key, value)
                                }
                            })

                    }
                    else
                    {
                        this.value = this.data.value
                        this.validate(this.value)
                    }
                }
                else
                {
                    this.controller.set_field("cad_num." + key, value)
                }
            }
        }
    }
}
</script>
